"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSettings = useSettings;
const react_1 = require("react");
const context_1 = require("./context");
function useSettings() {
    return (0, react_1.useContext)(context_1.SettingsContext);
}
//# sourceMappingURL=hook.js.map